import React, { Component } from "react";
import { Provider } from "react-redux";
import {
    Route,
    RouteComponentProps,
    Switch,
    withRouter
} from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import { hallsStore } from "../../store/store";
import HallsListContainer from "../HallsList/HallsListContainer.component";
import "./HallsPage.component.scss";
import HallPage from "../HallPage/HallPage.component";
import ServerPage from "../ServerPage/ServerPage.component";
import Footer from "../../../home/components/Footer/footer.component";

class HallsPage extends Component<RouteComponentProps, {}> {
    render() {
        return (
            <Provider store={hallsStore}>
                <div id="HallsPage">
                    <Route
                        render={({ location }) => (
                            <TransitionGroup>
                                <CSSTransition
                                    key={location.pathname + "-halls-page"}
                                    classNames="fade"
                                    timeout={550}
                                >
                                    <Switch location={location}>
                                        <Route
                                            exact
                                            path={"/halls"}
                                            component={HallsListContainer}
                                        />

                                        <Route
                                            path={
                                                "/halls/:hallId/servers/:serverId"
                                            }
                                            component={ServerPage}
                                        />

                                        <Route
                                            path={
                                                "/halls/:hallId/:detailSection?"
                                            }
                                            component={HallPage}
                                        />
                                    </Switch>
                                </CSSTransition>
                            </TransitionGroup>
                        )}
                    />
                    <Footer />
                </div>
            </Provider>
        );
    }
}

export default withRouter(HallsPage);
